module.exports = __webpack_public_path__ + "assets/img/cyCode.d620115e.png";